let globalLogoUrl = '';

export const setGlobalLogoUrl = (url: string) => {
  globalLogoUrl = url;
};

export const getGlobalLogoUrl = () => {
  return globalLogoUrl;
};

let navbarLogoUrl = '';

export const setNavbarLogo = (url: string) => {
  navbarLogoUrl = url;
};

export const getNavbarLogo = () => {
  return navbarLogoUrl;
};
